const styles = () => ({
  dialogTitle: {
    zIndex: 2,
  },
  dialogContent: {
    padding: '0 !important',
  },
  iFrame: {
    opacity: 1,
    width: '100%',
    height: '100%',
  },
});

export default styles;
